export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC = 10;
export const RESULT_PER_PAGE = 10;
export const KEY = "c87bd2ed-b23d-4646-8b63-3682cc99df0b";
export const MODEL_CLOSE_SEC = 1;
